module.exports = __webpack_public_path__ + "media/src/images/icon__soso-66462e22e159df021c47c00e3e758058.png";